import { render, staticRenderFns } from "./hoyesYellow.vue?vue&type=template&id=1831f354"
import script from "./hoyesYellow.vue?vue&type=script&lang=js"
export * from "./hoyesYellow.vue?vue&type=script&lang=js"
import style0 from "./hoyesYellow.vue?vue&type=style&index=0&id=1831f354&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports